// extracted by mini-css-extract-plugin
export default {"title":"MainPage_title__VwGDi","desc":"MainPage_desc__DHz3y","actions":"MainPage_actions__8fIzP","img":"MainPage_img__KM6xK"};